import * as React from 'react'
import { inject, observer } from 'mobx-react'
import styled from 'styled-components'
import { Row } from 'react-bootstrap'
import { LazyLoadImage } from 'react-lazy-load-image-component'
import 'react-lazy-load-image-component/src/effects/blur.css'
import { Product } from 'src/resources'
import { ChangeBtn } from 'src/components/atoms/input/buttons'
import MoreInfo from 'src/components/atoms/input/buttons/MoreInfo'
import QuantitySelect from 'src/components/atoms/configurator/QuantitySelect'
import PriceHeadline from 'src/components/atoms/configurator/PriceHeadline'
import { StoreProps } from 'src/stores'

export interface Props extends StoreProps {
  product: Product
  count?: number
  selected?: boolean
  highlight?: boolean
  quantityselect?: boolean
  quantityFactor?: number
  minQuantity?: number
  maxQuantity?: number
  autoclose?: boolean
  customQuantities?: Number[]
  onSelect: (product: Product, quantity: number) => void
  onQuantitySelect: (product: Product, count: number) => void
  setHighlight: (highlight: boolean, product?: Product) => void
}

interface State {
  showImage: boolean
}

@inject('confStore')
@observer
export default class ProductDetailCard extends React.Component<Props, State> {
  constructor(props) {
    super(props)
    this.state = { showImage: false }
  }

  static defaultProps = {
    count: 1,
    quantityFactor: 1
  }

  render() {
    const {
      confStore,
      count,
      highlight,
      onSelect,
      onQuantitySelect,
      product,
      quantityselect,
      quantityFactor,
      minQuantity,
      maxQuantity,
      customQuantities,
      selected,
      setHighlight
    } = this.props

    const returnPrice = () => {
      if (
        product.productType === 'OBITUARY' ||
        (product.productType === 'CARD' && product.quantity == 0)
      ) {
        return (
          <PriceHeadline
            border='none'
            service={product ? product.name : 'Lädt..'}
            price={confStore.calculateProductPrice(product, count)}
          />
        )
      } else {
        return (
          <PriceHeadline
            border='none'
            service={product ? product.name : 'Lädt..'}
            price={confStore.calculateProductPrice(product, count)}
          />
        )
      }
    }

    return (
      <CardWrapper highlighted={selected || highlight}>
        <ImageContainer
          background={
            product.productType === 'FLOWER' ||
            product.productType === 'COFFIN' ||
            product.productType === 'URN'
              ? 'white'
              : '#9ABBBF'
          }>
          <div onClick={() => setHighlight(!highlight, product)}>
            <LazyLoadImage
              alt='product_image'
              src={product.photos[0]}
              effect='blur'
              height='100%'
            />
          </div>
        </ImageContainer>
        <DataContainer>
          <Row>{returnPrice()}</Row>
          <ChangeButton
            id='selectOrUnselectProduct'
            onClick={() => {
              onSelect(
                product,
                customQuantities ? count : quantityFactor * count
              )
            }}
            isDelete={selected}>
            <div>{selected ? 'Entfernen' : 'Auswählen'}</div>
          </ChangeButton>
          {quantityselect && (
            <QuantitySelect
              value={count}
              minValue={minQuantity || quantityFactor}
              maxValue={maxQuantity || product.prices.length * quantityFactor}
              steps={quantityFactor}
              hidden={!selected}
              onSelect={(c) => onQuantitySelect(product, c)}
              customQuantities={customQuantities}
            />
          )}
          <MoreInfo onClick={() => setHighlight(!highlight, product)} />
        </DataContainer>
      </CardWrapper>
    )
  }
}

export const BigImageWrapper = styled.div`
  position: fixed;
  display: flex;
  top: 0;
  right: 0;
  background-color: #00000066;
  width: 100%;
  height: 100%;
  z-index: 5000;
  display: flex;
  justify-content: center;
  img {
    object-fit: contain;
    height: 100%;
    width: 100%;
  }
`

export const CardWrapper = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
  max-height: 450px;
  min-height: 400px;
  background-color: #d5e4e6;
  box-shadow: 0 9px 19px 0 rgba(0, 0, 0, 0.05);
  border: ${(props) =>
    props.highlighted ? '2px #677D7F solid' : '2px solid #D5E4E6'};
  transition: all 0.25s ease-in-out;

  &:hover {
    box-shadow: 0 20px 30px 0 rgba(0, 0, 0, 0.19);
  }
`

export const ImageContainer = styled.div`
  display: flex;
  justify-content: center;
  height: 50%;
  min-height: 250px;
  padding: 7.5px;
  background-color: ${(props) => props.background};

  img {
    object-fit: contain;
    height: 100%;
    width: 100%;
  }
`

export const DataContainer = styled.div`
  padding: 15px;
`

export const ChangeButton = styled(ChangeBtn)`
  position: absolute;
  left: 15px;
  bottom: 15px;
  width: 130px;
  height: 27px;
  padding: auto;
  line-height: 100%;
  font-size: 14px;
  text-align: center;
  text-transform: uppercase;
  ${(props) => props.isDelete && 'border-color: #974353; color: #974353;'}

  div {
    padding: 0px;
  }
`



// WEBPACK FOOTER //
// ./src/components/molecules/configurator/ProductDetailCard.tsx